var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terminated-insurances-CTA"},[_c('h2',[_vm._v(_vm._s(_vm.getPhrase('EndedInsurances')))]),_c('CycleButtonLink',{attrs:{"href":"beeindigde-verzekeringen-en-diensten","modifiers":"cta, secondary"}},[_vm._v(" "+_vm._s(_vm.getPhrase('EndedInsurances'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }